import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from '../CustomComponents/TableComponent'
import { getJobEventsHistory } from '../../store/reducer/jobSlice';
import PageHeader from '../../view/pageheader';
import moment from "moment-timezone";

const HistoryTable = () => {
    const { userJobEventHistoryData } = useSelector((state) => state.jobs)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const { id } = useParams()
    const [event_id1] = useState(searchParams.get("event_id"))
    const { count: totalCount, data: rawData = [] } = userJobEventHistoryData;

    const [columns, setColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    function getData(payload = {}) {
        const barcode = window.atob(id)
        const event_id = window.atob(event_id1)
        dispatch(getJobEventsHistory({ ...payload, barcode, event_id }));
    }
    useEffect(() => {
        getData();
    }, [])
    useEffect(() => {
        if (!rawData || rawData.length === 0) return;

        const dynamicFieldNames = new Set();

        const transformed = rawData.map((item) => {
            let parsedFields = [];
            try {
                parsedFields = JSON.parse(item.event_field_data || '[]');
            } catch (e) {
                console.error("Invalid event_field_data JSON", e);
            }

            const row = {
                ...item,
                created_at: moment(item.created_at).tz("America/New_York").format("MM-DD-YYYY hh:mm A"),
                user_name: item?.user?.user_name || "",
            };

            parsedFields.forEach(({ fieldName, value }) => {
                row[fieldName] = value;
                dynamicFieldNames.add(fieldName);
            });

            return row;
        });

        // List the dynamic fields you want to EXCLUDE
        const excludeFields = ['Spec', 'Barcode'];

        const fixedColumns = [
            {
                title: "Spec ID",
                dataIndex: "spec",
                key: "spec",
                align: "center",
            },
            {
                title: "Barcode",
                dataIndex: "barcode",
                key: "barcode",
                align: "center",
            },
            {
                title: "Event Name",
                dataIndex: "event_name",
                key: "event_name",
                align: "center",
            },
            {
                title: "User Name",
                dataIndex: "user_name",
                key: "user_name",
                align: "center",
            },
            {
                title: "Created At",
                dataIndex: "created_at",
                key: "created_at",
                align: "center",
            },
        ];

        // Only include fields NOT in the exclude list
        const dynamicColumns = Array.from(dynamicFieldNames)
            .filter(field => !excludeFields.includes(field))
            .map((field) => ({
                title: field,
                dataIndex: field,
                key: field,
                align: "center",
            }));

        setColumns([...fixedColumns, ...dynamicColumns]);
        setTableData(transformed);
    }, [rawData]);

    return (
        <>
            <PageHeader
                HeaderText={
                    <>
                        Job Event History
                    </>
                }
                Breadcrumb={[{ name: 'Jobs' }]}
                backgroundUrlName={true}

            />

            <TableComponent columns={columns} dataSource={tableData} totalCount={totalCount} />
        </>
    )
}

export default HistoryTable